__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "host";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@packages/shared", "1.0.0", () => (() => (__webpack_require__(6897))), 1);
			register("@packages/ui-components", "1.0.0", () => (() => (__webpack_require__(8302))), 1);
			register("@reduxjs/toolkit", "2.7.0", () => (() => (__webpack_require__(2299))), 1);
			register("@tanstack/react-query", "5.74.8", () => (() => (__webpack_require__(5411))), 1);
			register("@vkruglikov/react-telegram-web-app", "2.1.9", () => (() => (__webpack_require__(8697))), 1);
			register("axios", "1.9.0", () => (() => (__webpack_require__(3400))), 1);
			register("react-dom", "18.3.1", () => (() => (__webpack_require__(8316))), 1);
			register("react-hot-toast", "2.5.2", () => (() => (__webpack_require__(3225))), 1);
			register("react-redux", "9.2.0", () => (() => (__webpack_require__(8702))), 1);
			register("react-router-dom", "6.17.0", () => (() => (__webpack_require__(6034))), 1);
			register("react", "18.3.1", () => (() => (__webpack_require__(2784))), 1);
			initExternal(4435);
			initExternal(9116);
			initExternal(1795);
			initExternal(5920);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};